import * as React from 'react';

// The book's moves from the board's position, drawn from props only, in the
// best-moves place: headed "Theory", one row per book move with the opening
// it is or heads towards; a click plays it. `index.tsx` reads the book and
// the review and decides when this shows; stories pass the data by hand.

export interface TheoryMove {
  san: string;
  /** The opening this move is, or heads towards. */
  name: string;
  /** Plies to that opening after the move; 0 when the move reaches it. */
  distance: number;
}

export interface TheoryListProps {
  /** "4." or "4…", for the side to move. */
  movePrefix: string;
  /** Empty at the initial position, where the panel shows with no rows. */
  moves: TheoryMove[];
  onPlay: (san: string) => void;
}

export const TheoryList: React.FC<TheoryListProps> = ({ movePrefix, moves, onPlay }) => (
  <section className="panel review-shortlist-theory">
    <div className="theory-head">
      <h2>Theory</h2>
      {moves.length > 0 && <span className="theory-count">{moves.length} book {moves.length === 1 ? 'move' : 'moves'}</span>}
    </div>
    <ol className="theory-lines">
      {moves.map((m) => (
        <li key={m.san}>
          <button
            type="button"
            className="theory-line"
            title={m.distance === 0 ? `Play ${m.san}: ${m.name}` : `Play ${m.san}, ${m.distance} plies from ${m.name}`}
            onClick={() => onPlay(m.san)}>
            <span className="theory-move">
              {movePrefix} {m.san}
            </span>
            <span className="theory-name">{m.name}</span>
            <span className="theory-distance">{m.distance > 0 ? `in ${m.distance}` : ''}</span>
          </button>
        </li>
      ))}
    </ol>
  </section>
);
